import React, { useState, useEffect, useCallback } from "react";

import { CheckCircleFilled } from "@ant-design/icons";
import { Drawer, Button } from "antd";
import moment from "moment";

import MonthFrequencyForm from "../../../Env/components/MonthFrequencyForm";

// import WeekFrequencyForm from "../../../Env/components/WeekFrequencyForm";
import { formatDateForDisplay } from "../../../../utils/helpers";
import "./RecurrenceDateDrawer.css";

const RecurrenceDateDrawer = ({
  open, onClose, onSave, editingData,
}) => {
  const [scheduleType, setScheduleType] = useState("monthly");
  // Week frequency form
  const [startDate, setStartDate] = useState(moment().format("MM/DD/YYYY"));
  const [endDate, setEndDate] = useState(moment().add(1, "year").format("MM/DD/YYYY"));
  // const [weekDays, setWeekDays] = useState([]);
  // Month frequency form
  const [dayOfMonth, setDayOfMonth] = useState([]);
  const [recurrences, setRecurrences] = useState({ dates: [], frequency: "" });

  /**
   * Update frequency state and format for api payload
   * @param {Date[]} dates Dates
   * @param {"one-time" | "weekly" | "monthly" | "custom"} frequency Frequency
   */
  const updateRecurrence = (dates, frequency) => {
    setRecurrences({
      dates: dates.map((d) => moment(d, "MM/DD/YYYY").format("YYYY-MM-DD")),
      frequency,
    });
  };

  const initDefaultData = useCallback((data) => {
    const {
      dates, frequency, start_date: apiStartDate, end_date: apiEndDate,
    } = data;
    const dateList = dates.map((d) => formatDateForDisplay(d, "MM/DD/YYYY"));
    const start = formatDateForDisplay(apiStartDate, "MM/DD/YYYY");
    const end = formatDateForDisplay(apiEndDate, "MM/DD/YYYY");

    setRecurrences({
      dates: dates.map((d) => {
        const s = String(d);
        return /^\d{4}-\d{2}-\d{2}$/.test(s) ? s : moment(s).format("YYYY-MM-DD");
      }),
      frequency,
    });

    // if (frequency === "weekly") {
    //   setScheduleType("weekly");
    //   const weeks = [...new Set(dateList.map((d) => moment(d, "MM/DD/YYYY").format("dddd").toLowerCase()))];
    //   setStartDate(start);
    //   setEndDate(end);
    //   setWeekDays(weeks);
    // }

    if (frequency === "monthly") {
      setScheduleType("monthly");
      const days = [...new Set(dateList.map((d) => moment(d, "MM/DD/YYYY").date().toString().toLowerCase()))];
      setStartDate(start);
      setEndDate(end);
      setDayOfMonth(days);
    }
  }, []);

  useEffect(() => {
    if (editingData?.start_date && editingData?.end_date && editingData.dates?.length > 0) {
      initDefaultData(editingData);
    }
  }, [editingData, initDefaultData]);

  const isEditing = Boolean(editingData?.start_date);

  const apiDates = isEditing && editingData?.dates?.length ? editingData.dates : undefined;

  const isEndAfterStart = moment(endDate, "MM/DD/YYYY").isAfter(moment(startDate, "MM/DD/YYYY"), "day");
  const hasRecurrences = recurrences.dates.length > 0;
  const canSave = isEndAfterStart && hasRecurrences;

  const TABSDATA = {
    // weekly: {
    //   label: "Weekly",
    //   content: (
    //     <WeekFrequencyForm
    //       allowMultiple
    //       layout="supply-request-recurrence"
    //       updateSamplingData={updateRecurrence}
    //       startDate={startDate}
    //       setStartDate={setStartDate}
    //       endDate={endDate}
    //       setEndDate={setEndDate}
    //       weekDays={weekDays}
    //       setWeekDays={setWeekDays}
    //       allowPastStartDate
    //       apiDates={apiDates}
    //     />)
    //   ,
    // },
    monthly: {
      label: "Monthly",
      content: (
        <MonthFrequencyForm
          allowMultiple
          layout="supply-request-recurrence"
          updateSamplingData={updateRecurrence}
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          dayOfMonth={dayOfMonth}
          setDayOfMonth={setDayOfMonth}
          allowPastStartDate
          apiDates={apiDates}
        />
      ),
    },
  };

  const handleSaveOnClick = () => {
    onSave({
      ...recurrences,
      start_date: moment(startDate, "MM/DD/YYYY").format("YYYY-MM-DD"),
      end_date: moment(endDate, "MM/DD/YYYY").format("YYYY-MM-DD"),
    });
  };

  return (
    <Drawer
      title={(
        <div className="RecurrenceDateDrawer__Header">
          <h4>Schedule Date</h4>
          <div className="RecurrenceDateDrawer__Buttons">
            {/* <Button
              className={`RecurrenceDateDrawer__Button${scheduleType === "weekly" ? " RecurrenceDateDrawer__Button--active" : " RecurrenceDateDrawer__Button--inactive"}`}
              onClick={() => setScheduleType("weekly")}
            >
              {scheduleType === "weekly" && (
                <CheckCircleFilled className="RecurrenceDateDrawer__CheckIcon" />
              )}
              Weekly
            </Button> */}
            <Button
              className={`RecurrenceDateDrawer__Button${scheduleType === "monthly" ? " RecurrenceDateDrawer__Button--active" : " RecurrenceDateDrawer__Button--inactive"}`}
              onClick={() => setScheduleType("monthly")}
            >
              {scheduleType === "monthly" && (
                <CheckCircleFilled className="RecurrenceDateDrawer__CheckIcon" />
              )}
              Monthly
            </Button>
          </div>
        </div>
      )}
      placement="bottom"
      onClose={onClose}
      open={open}
      width={400}
      closeIcon={false}
      rootClassName="RecurrenceDateDrawer"
      footer={(
        <div className="RecurrenceDateDrawer__Footer">
          <Button type="default" htmlType="button" onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="button" onClick={handleSaveOnClick} disabled={!canSave}>Save</Button>
        </div>
      )}
      destroyOnClose
    >
      {TABSDATA[scheduleType].content}
    </Drawer>
  );
};

export default RecurrenceDateDrawer;
